import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    close: string;
    pendingStateLabel: string;
    clearButtonAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the back/close button to exit the search modal */
            close: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchList.close?c=17sxntureyrin", defaultMessage: "Quit Search" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Loading indicator label shown while search is in progress */
            pendingStateLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchList.pendingStateLabel?c=2xzqohvscs9ht", defaultMessage: "Searching" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the button that clears the search input */
            clearButtonAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchList.clearButtonAriaLabel?c=3e92inhv1e2pm", defaultMessage: "Clear search input" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
